import { useEffect, useState } from "react";
import api, { formatErr, ROLE_LABELS } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { SearchableSelect } from "./SearchableSelect";
import { UserCheck } from "lucide-react";
import { toast } from "sonner";

export const AssignAuditorDialog = ({ audit, onOpenChange, onAssigned }) => {
  const [users, setUsers] = useState([]);
  const [auditorId, setAuditorId] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (audit) {
      setAuditorId("");
      api.get("/users/assignable").then((r) => setUsers(r.data));
    }
  }, [audit]);

  const assign = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/audits/${audit.id}/assign`, { auditor_id: auditorId });
      toast.success(`Assigned to ${data.auditor_name} — they have been notified`);
      onOpenChange(false);
      onAssigned?.();
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!audit} onOpenChange={onOpenChange}>
      <DialogContent data-testid="assign-auditor-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><UserCheck className="w-5 h-5 text-[#14532D]" />Assign Auditor</DialogTitle>
          <DialogDescription>
            {audit && <>{audit.template_name} at {audit.hotel_name} — due {audit.due_date?.slice(0, 10)}</>}
          </DialogDescription>
        </DialogHeader>
        <SearchableSelect testId="assign-auditor-select" placeholder="Search auditor..."
          options={users.map((u) => ({ value: u.id, label: u.name, sub: ROLE_LABELS[u.role] || u.role }))}
          value={auditorId} onChange={setAuditorId} />
        <Button data-testid="assign-auditor-save" onClick={assign} disabled={!auditorId || saving} className="w-full bg-[#14532D] hover:bg-[#166534]">
          {saving ? "Assigning..." : "Assign & Notify"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
